import { useTranslation } from 'react-i18next';

import { WorkoutPlanType } from 'types/workouts';

import { useWorkoutPlanCopy } from '../../hooks/useWorkoutPlanCopy';

import * as S from './styled';

type PlanItemProps = {
    done?: boolean;
    plan: Pick<WorkoutPlanType, 'name' | 'preview' | 'hash' | 'workout_time' | 'workout_id'>;
    onClick: (item: Pick<WorkoutPlanType, 'hash' | 'workout_id'>) => void;
};

const PlanItem = ({
    done = false,
    plan: { hash, workout_time, preview, name, workout_id },
    onClick,
}: PlanItemProps) => {
    const { t } = useTranslation();
    const {
        planItem: { defaultPlanName },
    } = useWorkoutPlanCopy();
    const handleOnClick = () => onClick({ hash, workout_id });
    const showStartButton = !(hash === null && workout_id === null);

    return (
        <S.Item data-testid="plan-item" $done={done}>
            <S.InfoContainer>
                <S.PlanName>{name || defaultPlanName}</S.PlanName>
                <S.Duration $mb={done ? 0 : 16}>{t('workout.duration', { duration: workout_time })}</S.Duration>
            </S.InfoContainer>
            {done ? (
                <S.Checkmark title="Workout finished" />
            ) : (
                <>
                    {showStartButton && (
                        <S.StartButton onClick={handleOnClick} size="small">
                            <S.ButtonText>{t('basics.start')}</S.ButtonText>
                        </S.StartButton>
                    )}
                    <S.Preview $done={done} src={preview} alt="Workout cover image" />
                </>
            )}
        </S.Item>
    );
};

export default PlanItem;
